let prodHost = "https://api-developer.astomverse.com"
let localHost = "http://localhost:8080"
const baseUrl = prodHost + "/api/v1";

export default baseUrl;
